import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon

import '@/permission' // permission control
import Print from 'vue-print-nb'

// import VueClipboard from 'vue-clipboard2'
import VueClipboard from 'vue-clipboard2'

import VueViewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import JsonExcel from 'vue-json-excel'
import * as VueGoogleMaps from 'vue2-google-maps'
import Plugin from 'v-fit-columns';

Vue.use(ElementUI, { locale })
Vue.use(VCharts)
Vue.use(Print);
Vue.use(Plugin);
// Vue.use(JsonExcel);

Vue.component('downloadExcel', JsonExcel);
Vue.use(VueClipboard);
Vue.use(VueViewer, {
  defaultOptions: {
    button: false,
    navbar: false,
    title: false,
    toolbar: true,
  }
});
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDBF8YB2y6zDrbSDYOK-ZqPZIVOi9_7oHo',
  },
  installComponents: true
});
Vue.config.productionTip = false
// Vue.use(VueClipboard);

//全局注册指令----回车事件下一个input获取焦点
Vue.directive("focusNextOnEnter", {
  bind: function (el, { value }, vnode) {
    el.addEventListener("keyup", ev => {
      if (ev.keyCode === 13) {
        let nextInput = vnode.context.$refs[value];
        if (nextInput && typeof nextInput.focus === "function") {
          nextInput.focus();
          nextInput.select();
        }
      }
    });
  }
});

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js